import moment from 'moment';

export const humanizeDuration = (duration_ms: number): string => {
    const durationFormatted = moment.duration(duration_ms).humanize(false);
    return durationFormatted;
    // return duration.format('d [days], h [hours], m [minutes], s [seconds]');
}
